module.exports = {
    'demoModule.title':'Titolo modulo gMap',
    'gMapModule.mapDeleteShapeButton':'Elimina la forma selezionata',
    'gMapModule.mapDirectionPathLenght':'Lunghezza percorso:',
    'gMapModule.mapCreateRoute':'Crea percorso',
    'gMapModule.mapDeleteDirection':'Elimina percorso',
    'gMapModule.mapShowTrafficLayer':'Mostra traffico',
    'gMapModule.mapShowTransitLayer':'Mostra transito',
    'gMapModule.mapEnterAddress': 'Cerca indirizzo',
    'gMapModule.doubleClickToOpenEvent': 'Doppio click per visualizzare i dettagli',
    'gMapModule.dblClick4Details': 'Doppio click per dettagli',
    'gMapModule.directionOrigin': 'Scegli punto d\'inizio',
    'gMapModule.directionDestination': 'Scegli punto di destinazione',
    'gMapModule.directionByDriving': 'Auto',
    'gMapModule.directionByTransit': 'Trasporto pubblico',
    'gMapModule.directionByWalking': 'A piedi',
    'gMapModule.directionByBycicling': 'Bicicletta',
    'gMapModule.routeSelectOption': 'Selezionare un\'opzione dalla lista',
    'gMapModule.routeError': 'Si è verificato un errore. Si prega di riprovare',
    'gMapModule.routeNoResult': 'Nessun risultato trovato',
    'gMapModule.routeSearchOnMap': 'Cerca sulla mappa'
    
};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/languages/it.js
// module id = 333
// module chunks = 0